import { useCallback } from 'react';
import { useAsync } from '@util/customhooks/useAsync';
import firebase from 'firebase/app';
import 'firebase/functions';

type EmailPair = { id: string | null; email: string | null };

export const useEmails = (ids: string[] | undefined, cloudFunctionName: string) => {
  const getEmails = useCallback(async () => {
    if (!ids) {
      return null;
    }

    const cloudFunction = firebase.functions().httpsCallable(cloudFunctionName);

    const emails = await cloudFunction({
      ids,
    });

    if (emails.data.status === 'error') {
      throw new Error(emails.data.message);
    }
    return emails.data.result.pairs as EmailPair[];
  }, [ids, cloudFunctionName]);

  return useAsync<EmailPair[] | null>(getEmails);
};
